/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Category } from './';
import {
    CategoryFromJSON,
    CategoryFromJSONTyped,
    CategoryToJSON,
} from './';
import type { Duration } from './';
import {
    DurationFromJSON,
    DurationFromJSONTyped,
    DurationToJSON,
} from './';
import type { JobTitle } from './';
import {
    JobTitleFromJSON,
    JobTitleFromJSONTyped,
    JobTitleToJSON,
} from './';
import type { ProjectDescription } from './';
import {
    ProjectDescriptionFromJSON,
    ProjectDescriptionFromJSONTyped,
    ProjectDescriptionToJSON,
} from './';
import type { ProjectTitle } from './';
import {
    ProjectTitleFromJSON,
    ProjectTitleFromJSONTyped,
    ProjectTitleToJSON,
} from './';
import type { Skill } from './';
import {
    SkillFromJSON,
    SkillFromJSONTyped,
    SkillToJSON,
} from './';
import type { WorkConditions } from './';
import {
    WorkConditionsFromJSON,
    WorkConditionsFromJSONTyped,
    WorkConditionsToJSON,
} from './';

/**
 * 
 * @export
 * @interface ExtractedInformationFromSearchAndProfiles
 */
export interface ExtractedInformationFromSearchAndProfiles {
    /**
     * 
     * @type {JobTitle}
     * @memberof ExtractedInformationFromSearchAndProfiles
     */
    jobTitle?: JobTitle;
    /**
     * 
     * @type {Array<Skill>}
     * @memberof ExtractedInformationFromSearchAndProfiles
     */
    skills: Array<Skill>;
    /**
     * Freelancers preferred categories to help skills suggestion
     * @type {Array<Category>}
     * @memberof ExtractedInformationFromSearchAndProfiles
     */
    preferredCategories: Array<Category>;
    /**
     * 
     * @type {WorkConditions}
     * @memberof ExtractedInformationFromSearchAndProfiles
     */
    workCondition?: WorkConditions;
    /**
     * 
     * @type {ProjectTitle}
     * @memberof ExtractedInformationFromSearchAndProfiles
     */
    projectTitle?: ProjectTitle;
    /**
     * 
     * @type {ProjectDescription}
     * @memberof ExtractedInformationFromSearchAndProfiles
     */
    description?: ProjectDescription;
    /**
     * 
     * @type {Duration}
     * @memberof ExtractedInformationFromSearchAndProfiles
     */
    duration?: Duration;
}

/**
 * Check if a given object implements the ExtractedInformationFromSearchAndProfiles interface.
 */
export function instanceOfExtractedInformationFromSearchAndProfiles(value: object): value is ExtractedInformationFromSearchAndProfiles {
    if (!('skills' in value) || value['skills'] === undefined) return false;
    if (!('preferredCategories' in value) || value['preferredCategories'] === undefined) return false;
    return true;
}

export function ExtractedInformationFromSearchAndProfilesFromJSON(json: any): ExtractedInformationFromSearchAndProfiles {
    return ExtractedInformationFromSearchAndProfilesFromJSONTyped(json, false);
}

export function ExtractedInformationFromSearchAndProfilesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExtractedInformationFromSearchAndProfiles {
    if (json == null) {
        return json;
    }
    return {
        
        'jobTitle': json['jobTitle'] == null ? undefined : JobTitleFromJSON(json['jobTitle']),
        'skills': ((json['skills'] as Array<any>).map(SkillFromJSON)),
        'preferredCategories': ((json['preferredCategories'] as Array<any>).map(CategoryFromJSON)),
        'workCondition': json['workCondition'] == null ? undefined : WorkConditionsFromJSON(json['workCondition']),
        'projectTitle': json['projectTitle'] == null ? undefined : ProjectTitleFromJSON(json['projectTitle']),
        'description': json['description'] == null ? undefined : ProjectDescriptionFromJSON(json['description']),
        'duration': json['duration'] == null ? undefined : DurationFromJSON(json['duration']),
    };
}

export function ExtractedInformationFromSearchAndProfilesToJSON(value?: ExtractedInformationFromSearchAndProfiles | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'jobTitle': JobTitleToJSON(value['jobTitle']),
        'skills': ((value['skills'] as Array<any>).map((v) => SkillToJSON(v))),
        'preferredCategories': ((value['preferredCategories'] as Array<any>).map((v) => CategoryToJSON(v))),
        'workCondition': WorkConditionsToJSON(value['workCondition']),
        'projectTitle': ProjectTitleToJSON(value['projectTitle']),
        'description': ProjectDescriptionToJSON(value['description']),
        'duration': DurationToJSON(value['duration']),
    };
}

